const isNull = <V>(value: V | null | undefined): value is null | undefined =>
  value === undefined || value == null;

const nvl = <T>(value: T | null | undefined, defaultValue: T): T =>
  isNull(value) ? defaultValue : value;

const isEmpty = (value: unknown): value is null | undefined =>
  isNull(value) || (typeof value === 'string' && value.trim().length === 0);

const isNotEmpty = <T>(value: T | null | undefined): value is T =>
  !isEmpty(value);

export { isNull, nvl, isEmpty, isNotEmpty };
